import { useDisclosure } from '@chakra-ui/hooks';
import DeleteModal from 'components/actions/Delete';
import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import SupplierStats from './components/customerStats';
import GoBack from 'components/actions/GoBack';
import CustomerInfoPreview from './components/CustomerInfoPreview';
import SupplierPurchases from './components/SupplierPurchases';
import SupplierProducts from './components/SupplierProducts';
import PendingArrivals from './components/PendingArrivals';
import { getSupplierPage, archiveSupplier } from 'interfaces/supplier';

const EditSupplier = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { isOpen, onClose } = useDisclosure();
    const [customer, setCustomer] = useState<any>(null);

    const initCustomer = async (id: string) => {
        const res = await getSupplierPage(id);
        if (res) {
            setCustomer(res);
            return;
        }
        navigate('/suppliers');
    };

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/login');
        }
        initCustomer(params.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="mt-1 col-span-12">
                <GoBack text="Mes clients" />
            </div>
            <div className="mt-2 grid grid-cols-12 gap-3">
                <SupplierStats id={customer && customer._id} />
                <DeleteModal
                    isOpen={isOpen}
                    onClose={onClose}
                    description="Êtes-vous sûr de vouloir archiver ce fournisseur ?"
                    context="un fournisseur"
                    archived={true}
                    deleteFunction={async () => {
                        await archiveSupplier(params.id);
                        navigate('/suppliers');
                    }}
                />
                <CustomerInfoPreview customer={customer} />
                <SupplierPurchases id={customer && customer._id} />
                <div className="col-span-12">
                    <SupplierProducts id={customer && customer._id} />
                </div>
                <div className="col-span-12">
                    <PendingArrivals id={customer && customer._id} />
                </div>
            </div>
        </>
    );
};

export default EditSupplier;
